import DocumentAssociation from '@core/classes/DocumentAssociation';

export class PlaidRequest {
	associations?: DocumentAssociation[];
	customerId?: string;
	plaidItemIds?: string[];
	storeCode?: string;
	request?: any;

	constructor(init?: PlaidRequest) {
		this.associations = init?.associations ?? [];
		this.customerId = init?.customerId;
		this.plaidItemIds = init?.plaidItemIds ?? [];
		this.storeCode = init?.storeCode;
		this.request = init?.request;
	}

	static create(request: any, options?: IPlaidRequestOptions): PlaidRequest {
		return new PlaidRequest({
			associations: options?.associations ?? [],
			customerId: options?.customerId,
			plaidItemIds: options?.plaidItemIds ?? [],
			storeCode: options?.storeCode,
			request,
		});
	}
}

export interface IPlaidRequestOptions {
	associations?: DocumentAssociation[];
	customerId?: string;
	plaidItemIds?: string[];
	storeCode?: string;
}
